<template lang="html">
	<entity-page id="page__prices" v-loader-overlay="progress">
		<template slot="header-right">
			<z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
			<z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
		</template>
		<div slot="default">
			<toggle-card heading="Направление" v-bind:visibility="true">
				<div class="row">
					<z-select 
						label="Тип отправления" v-model="price.from" :required="true" name="from" id="from"
						v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('from')"
						v-on:input="resetId('from')" class="col-6"
					>
						<option value=""> Выбрать... </option>
						<option value="city"> Из населённого пункта </option>
						<option value="zone"> Из направления </option>
					</z-select>        
					<z-input-autocomplete
						v-show="price.from == 'city'" 
						v-model="price.city_id_from" display-property="label" property="id" class="col-6"
						v-bind:callback="getCities" v-on:select="selectFromCity" v-bind:length-on-search="3" v-bind:update-on-input="false"
						v-bind:default="(price.city_from && price.city_from.name) ? price.city_from.name : ''"
						id="city_id_from" name="city_id_from" label="Населённый пункт"
						v-validate="{required: price.from == 'city'}" data-vv-name="city_id_from" v-bind:error="errors.first('city_id_from')" v-bind:data-vv-as="' '"
					></z-input-autocomplete>

					<z-input-autocomplete
						v-show="price.from == 'zone'" 
						v-model="price.zone_id_from" display-property="label" property="id"
						v-bind:callback="getZones" v-bind:length-on-search="3" v-bind:update-on-input="false"
						v-bind:default="(price.zone_from && price.zone_from.name) ? price.zone_from.name : ''"
						id="zone_id_from" name="zone_id_from" label="Направление" class="col-6"
						v-validate="{required: price.from == 'zone'}" data-vv-name="zone_id_from" v-bind:error="errors.first('zone_id_from')" v-bind:data-vv-as="' '"
					></z-input-autocomplete>
				</div>
			</toggle-card>
			<toggle-card heading="Назначение" v-bind:visibility="true">
				<div class="row">
					<z-select
						label="Тип назначения" v-model="price.to" :required="true" name="to" id="to"
						v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('to')"
						v-on:input="resetId('to')" class="col-6"
					>
						<option value=""> Выбрать... </option>
						<option value="city"> В населённый пункт </option>
						<option value="zone"> В направление </option>
					</z-select>
					<z-input-autocomplete
						v-show="price.to == 'city'" class="col-6"
						v-model="price.city_id_to" display-property="label" property="id"
						v-bind:callback="getCities" v-on:select="selectToCity" v-bind:length-on-search="3" v-bind:update-on-input="false"
						v-bind:default="(price.city_to && price.city_to.name) ? price.city_to.name : ''"
						id="city_id_to" name="city_id_to" label="Населённый пункт"
						v-validate="{required: price.to == 'city'}" data-vv-name="city_id_to" v-bind:error="errors.first('city_id_to')" v-bind:data-vv-as="' '"
					></z-input-autocomplete>

					<z-input-autocomplete
						v-show="price.to == 'zone'" class="col-6"
						v-model="price.zone_id_to" display-property="label" property="id"
						v-bind:callback="getZones" v-bind:length-on-search="3" v-bind:update-on-input="false"
						v-bind:default="(price.zone_to && price.zone_to.name) ? price.zone_to.name : ''"
						id="zone_id_to" name="zone_id_to" label="Направление"
						v-validate="{required: price.to == 'zone'}" data-vv-name="zone_id_to" v-bind:error="errors.first('zone_id_to')" v-bind:data-vv-as="' '"
					></z-input-autocomplete>
				</div>
			</toggle-card>
			<z-select 
				label="Тип расчёта" v-model="price.type" :required="true" name="type" id="type"
				v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('type')"
			>
				<option v-bind:value="null"> Выбрать... </option>
				<option v-bind:value="1"> По весу </option>
				<option v-bind:value="2"> По объёму </option>
			</z-select>
			<z-select
				v-bind:label="'Тип расчёта цены по' + (parseInt(price.type) == 2 ? ' объёму' : ' весу')"
				v-model="price.is_min" :required="true" name="is_min" id="is_min"
				v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('is_min')"
			>
				<option v-bind:value="null"> Выбрать... </option>
				<option v-bind:value="0"> {{ 'За единицу' + (parseInt(price.type) == 2 ? ' объёма' : ' веса')}} </option>
				<option v-bind:value="1"> {{ 'За весь' + (parseInt(price.type) == 2 ? ' объём' : ' вес') }} </option>
			</z-select>
			<div v-show="parseInt(price.type) == 2" class="row">
				<z-input
					v-bind:disabled="(parseInt(price.is_min) == 1 || parseInt(price.type) == 1)" v-bind:readonly="(parseInt(price.is_min) == 1 || parseInt(price.type) == 1)"
					v-model="price.price_volume" label="Цена за ед. объёма" name="price_volume" id="price_volume" data-vv-name="price_volume"
					v-validate="{'required': parseInt(price.type) == 2, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" v-bind:required="parseInt(price.type) == 2" 
					v-bind:error="errors.first('price_volume')" type="number" class="col-6"  v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-bind:disabled="(parseInt(price.is_min) == 1 || parseInt(price.type) == 1)" v-bind:readonly="(parseInt(price.is_min) == 1 || parseInt(price.type) == 1)"
					v-model="price.volume_min" label="Минимальный объём" name="volume_min" id="volume_min" class="col-6" data-vv-name="volume_min"
					v-validate="{'required': parseInt(price.type) == 2, min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
					v-bind:required="parseInt(price.type) == 2" v-bind:error="errors.first('volume_min')" type="number"  v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-bind:disabled="parseInt(price.type) == 1" v-bind:readonly="parseInt(price.type) == 1"
					v-model="price.volume_max" label="Максимальный объём" name="volume_max" id="volume_max" class="col-6" data-vv-name="volume_max"
					v-validate="{'required': parseInt(price.type) == 2, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
					v-bind:required="parseInt(price.type) == 2" v-bind:error="errors.first('volume_max')" type="number"  v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-bind:disabled="(parseInt(price.is_min) == 0 || parseInt(price.type) == 1)" v-bind:readonly="(parseInt(price.is_min) == 0 || parseInt(price.type) == 1)"
					v-model="price.price_volume_min" label="Стоимость за максимальный объём" name="price_volume_min" id="price_volume_min"
					v-validate="{'required': parseInt(price.type) == 2, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" v-bind:required="parseInt(price.type) == 2" 
					v-bind:error="errors.first('price_volume_min')" type="number" class="col-6"  data-vv-name="price_volume_min" v-bind:data-vv-as="' '"
				></z-input>
			</div>
			<div v-show="parseInt(price.type) == 1" class="row">
				<z-input
					v-bind:disabled="(parseInt(price.is_min) == 1 || parseInt(price.type) == 2)" v-bind:readonly="(parseInt(price.is_min) == 1 || parseInt(price.type) == 2)"
					v-model="price.price_weight" label="Цена за ед. веса" name="price_weight" id="price_weight"
					v-validate="{'required': parseInt(price.type) == 1, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" v-bind:required="parseInt(price.type) == 1"
					v-bind:error="errors.first('price_weight')" type="number" class="col-6" data-vv-name="price_weight" v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-bind:disabled="(parseInt(price.is_min) == 1 || parseInt(price.type) == 2)" v-bind:readonly="(parseInt(price.is_min) == 1 || parseInt(price.type) == 2)"
					v-model="price.weight_min" label="Минимальный вес" name="weight_min" id="weight_min" v-bind:data-vv-as="' '" data-vv-name="weight_min"
					v-validate="{'required': parseInt(price.type) == 1, min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
					v-bind:required="parseInt(price.type) == 1" v-bind:error="errors.first('weight_min')" type="number" class="col-6"
				></z-input>
				<z-input
					v-bind:disabled="(parseInt(price.type) == 2)" v-bind:readonly="(parseInt(price.type) == 2)"
					v-model="price.weight_max" label="Максимальный вес" name="weight_max" id="weight_max" class="col-6" data-vv-name="weight_max"
					v-validate="{'required': parseInt(price.type) == 1, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
					v-bind:required="parseInt(price.type) == 1" v-bind:error="errors.first('weight_max')" type="number"  v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-bind:disabled="(parseInt(price.is_min) == 0 || parseInt(price.type) == 2)" v-bind:readonly="(parseInt(price.is_min) == 0 || parseInt(price.type) == 2)"
					v-model="price.price_weight_min" label="Стоимость за максимальный вес" name="price_weight_min" id="price_weight_min"
					v-validate="{'required': parseInt(price.type) == 1, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" v-bind:required="parseInt(price.type) == 1" 
					v-bind:error="errors.first('price_weight_min')" type="number" class="col-6" data-vv-name="price_weight_min" v-bind:data-vv-as="' '"
				></z-input>
			</div>
		</div>
	</entity-page>
</template>
<script>
	import ZInput  from '@/components/ZInput';
	import ZSelect from '@/components/ZSelect';
	import EntityPage   from '@/components/EntityPage.vue';
	import ToggleCard   from '@/components/ToggleCard';
	import ZIconButton  from '@/components/ZIconButton.vue';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	export default {
		components: { ZInput, ZSelect, ZInputAutocomplete, EntityPage, ToggleCard, ZIconButton},
		data() {
			return {
				price: {},
				priceDefault: {
					id: null,
					zone_id_from: null,
					zone_id_to:   null,
					city_id_from: null,
					city_id_to:   null,
					price_weight: null,
					price_volume: null,
					price_volume_min: null,
					price_weight_min: null,
					volume_min: null,
					weight_min: null,
					volume_max: null,
					weight_max: null,
					is_min: 0,
					type: 1,
				},
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['load-price-card'];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			}
		},
		created() {
			this.init();
		},
		methods: {
			/**
			 * Возвращение пользователя на предидущую страницу
			 */
			back() {
				this.$router.push({name: 'Prices', query: this.$route.query});
			},
			/**
			 * Инициализация компонента
			 */
			async init() {
				this.$store.commit('setTitle', 'Цены');
				this.$store.commit('openRightPanel');

				if (this.$route.params.price_id && this.$route.params.price_id != 'new')
					this.price = await this.getPrice(this.$route.params.price_id);
				else {
					this.price = Object.assign({}, this.priceDefault);
					if (this.$route.query && this.$route.query.clone_id)
						this.price = await this.getPrice(this.$route.query.clone_id);
				}

				this.price.from = this.price.city_id_from ? 'city' : 'zone';
				this.price.to   = this.price.city_id_to   ? 'city' : 'zone';
			},
			/**
			 * Получение цены
			 */
			getPrice(id) {
				this.$store.commit('showProgressBar', 'load-price-card');
				return this.$store.dispatch('cost/getPrice', { id: id })
					.finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
			},
			/**
			 * Сохранение цены
			 */
			save() {
				this.$validator.validateAll().then(valid => {
					if (!valid) return;
					if (this.$route.params.price_id != 'new') this.putPrice();
					else this.postPrice();
				})
			},
			/**
			 * Добавление цены
			 */
			postPrice() {
				this.$store.commit('showProgressBar', 'load-price-card');
				this.$store.dispatch('cost/addPrice', {price: this.price}).then(r => {
					if (!r) return;
					this.$router.push({name: 'Price', params: {price_id: r.id}});
					this.$root.$emit('reload-table', 'prices');
				}).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
			},
			/**
			 * Изменение цены
			 */
			putPrice() {
				this.$store.commit('showProgressBar', 'load-price-card');
				this.$store.dispatch('cost/updatePrice', {price: this.price}).then(r => {
					if (!r) return;
					this.getPrice(r.id);
					this.$root.$emit('reload-table', 'prices');
				}).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
			},
			/**
			 * Автозаполнение города
			 */
			getCities(searchString) {
				if (searchString.length >= 3) return this.$store.dispatch('stock/getCities', { name: searchString }).then(async r => {
					if (!r || !r.length) r = [];

					r.map(item => Object.assign(item, {
					value: item.value || item.name,
					label: item.value || item.name
					}));

					return r.concat(await this.suggestCity(searchString, r.map(item => item.name)));
				});
			},
			/**
			 * Предложение города
			 */
			suggestCity(searchString, existsNames) {
				return this.$store.dispatch('cost/suggestCity', { string: searchString }).then(r => {
					if (!r || !r.length) return [];
					return r.filter(item => item && !item.data.street) //Убираем из подсказок адреса, где есть улица т.к это уже не населённый пункт
						.filter(item => item.data.city || item.data.settlement) //Оставляем только варианты с городом либо населённым пунктом
						.filter(item => !!item.unrestricted_value)
						.map(item => { //Подготавливаем объекты с адресами городов и нас. пунктов
							return {
								id: null,
								name:   item.data.settlement ? (item.data.settlement + ' ' + item.data.settlement_type) : (item.data.city + ' ' + item.data.city_type),
								aoguid: item.data.settlement_fias_id ? item.data.settlement_fias_id : item.data.city_fias_id,
								okato:  item.data.okato,
								parentguid: (item.data.region_fias_id) ? item.data.region_fias_id : null,
								disid:      null,
								regioncode: null,
								zone_id:    null,
								sort:       10,
								value: item.unrestricted_value ? item.unrestricted_value : '',
								label: item.unrestricted_value ? item.unrestricted_value : '',
							};
						}).filter(item => item.value && item.label).filter(item => (!(existsNames.indexOf(item.name)+1))); //Оставляем в результате только те, которых ещё нет в списке
				});
			},
			/**
			 * Автозаполнение зоны
			 */
			getZones(searchString) {
				if (searchString.length < 3) return;
				return this.$store.dispatch('stock/getZones', { name: searchString }).then(r => {
					return r.map(item => Object.assign(item, {label: item.name}));
				});
			},
			/**
			 * Cброс id города/зоны при смене типа пункта отправления/назначения
			 */
			resetId(type) {
				switch(this.price[type]) {
					case 'city': this.price['zone_id_' + type] = null; break;
					case 'zone': this.price['city_id_' + type] = null; break;
				}
			},
			/**
			 * Добавление города
			 */
			addCity(city) {
				this.$store.commit('showProgressBar', 'load-price-card');
				city.suggest = true;
				return this.$store.dispatch('cost/addCity', { city: city }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
			},
			/**
			 * Выбор города для отправления
			 */
			async selectFromCity(id, city) {
				if (!id || id == 'new') city = await this.addCity(city);
				if (!city || !city.id) return;

				this.price.city_id_from = city.id;
				this.price.city_from = Object.assign({}, city); 
			},
			/**
			 * Выбор города для назначения
			*/
			async selectToCity(id, city) {
				if (!id || id == 'new') city = await this.addCity(city);
				if (!city || !city.id) return;

				this.price.city_id_to = city.id;
				this.price.city_to    = Object.assign({}, city);
			},
		},
		watch: {
			'$route.params.price_id'() {
				this.$nextTick(() => this.init());
			},
			'price.type'() {
				if (parseInt(this.price.type) == 1) {
					this.price.price_volume = null;
					this.price.price_volume_min = null;
					this.price.volume_min = null;
					this.price.volume_max = null;
				} else {
					this.price.price_weight = null;
					this.price.price_weight_min = null;
					this.price.weight_min = null;
					this.price.weight_max = null;
				}
			},
			'price.is_min'(value) {
				if (parseInt(value) == 1) {
					this.price.volume_min = null;
					this.price.weight_min = null;
					this.price.price_weight = null;
					this.price.price_volume = null;
				} else {
					this.price.price_volume_min = null;
					this.price.price_weight_min = null; 
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Price.vue?8c7e0b92